import { pickBy } from 'lodash';
import { generateKeys, generateLocalization } from '../utils';
export const frontends = generateKeys({
    web: {
        value: 'web',
    },
    web2: {
        value: 'web2',
    },
    mobile: {
        value: 'mobile',
    },
});
export const mobileOperatingSystem = generateKeys({
    android: {
        value: 'Android',
    },
    ios: {
        value: 'iOS',
    },
});
export const platforms = generateKeys({
    app: {
        value: 'app',
    },
    web: {
        value: 'web',
    },
});
export const platformTypes = generateKeys({
    desktop: {
        value: 'desktop',
    },
    mobile: {
        value: 'mobile',
    },
});
export const viewerTypes = generateKeys({
    user: {
        value: 'user',
        hasNumericId: true,
    },
    client: {
        value: 'client',
        hasNumericId: true,
    },
    service: {
        value: 'service',
        hasNumericId: false,
    },
    demoClient: {
        value: 'demoClient',
        hasNumericId: false,
    },
});
export const yesNo = generateLocalization('yesNo', generateKeys({
    yes: {
        value: 'yes',
        label: 'Yes',
        boolValue: true,
        localization: { id: '', defaultMessage: '' },
    },
    no: {
        value: 'no',
        label: 'No',
        boolValue: false,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const pspCryptoCurrency = generateKeys({
    PAX: {
        value: 'PAX',
        label: 'PAX',
    },
    BCH: {
        value: 'BCH',
        label: 'BCH',
    },
    DASH: {
        value: 'DASH',
        label: 'DASH',
    },
    LTC: {
        value: 'LTC',
        label: 'LTC',
    },
    XRP: {
        value: 'XRP',
        label: 'XRP',
    },
    ZEC: {
        value: 'ZEC',
        label: 'ZEC',
    },
    USDC: {
        value: 'USDC',
        label: 'SDC (ERC20)',
    },
});
export const currencies = generateKeys({
    EUR: {
        value: 'EUR',
        label: 'EUR',
        symbol: '\u20ac',
        allowNewAccounts: true,
        canDeposit: true,
        portfolioManagement: true,
        allowDynamicLeverage: true,
    },
    USD: {
        value: 'USD',
        label: 'USD',
        symbol: '$',
        allowNewAccounts: true,
        canDeposit: true,
        portfolioManagement: true,
        allowDynamicLeverage: true,
    },
    USDT: {
        value: 'USDT',
        label: 'Tether',
        symbol: '₮',
        isCrypto: true,
        canDeposit: true,
        allowNewAccounts: false,
        allowNewCryptoWallets: false,
    },
    GBP: {
        value: 'GBP',
        label: 'GBP',
        symbol: '£',
        allowNewAccounts: true,
        canDeposit: true,
        portfolioManagement: true,
    },
    PLN: {
        value: 'PLN',
        label: 'PLN',
        symbol: 'PLN',
        allowNewAccounts: false,
        canDeposit: true,
    },
    CHF: {
        value: 'CHF',
        label: 'CHF',
        symbol: 'CHF',
        allowNewAccounts: false,
        canDeposit: true,
    },
    SEK: {
        value: 'SEK',
        label: 'SEK',
        symbol: 'SEK',
        allowNewAccounts: false,
        canDeposit: true,
    },
    DKK: {
        value: 'DKK',
        label: 'DKK',
        symbol: 'DKK',
        allowNewAccounts: false,
        canDeposit: true,
    },
    NOK: {
        value: 'NOK',
        label: 'NOK',
        symbol: 'NOK',
        allowNewAccounts: false,
        canDeposit: true,
    },
    ETH: {
        value: 'ETH',
        label: 'ETH',
        symbol: 'ETH',
        allowNewAccounts: false,
        canDeposit: true,
        isCrypto: true,
        allowNewCryptoWallets: false,
    },
    BTC: {
        value: 'BTC',
        label: 'BTC',
        symbol: 'BTC',
        allowNewAccounts: false,
        canDeposit: true,
        isCrypto: true,
        allowNewCryptoWallets: true,
    },
    BCH: {
        value: 'BCH',
        label: 'BCH',
        symbol: 'BCH',
        allowNewAccounts: false,
        canDeposit: true,
        isCrypto: true,
    },
    LTC: {
        value: 'LTC',
        label: 'LTC',
        symbol: 'LTC',
        allowNewAccounts: false,
        canDeposit: true,
        isCrypto: true,
    },
    DASH: {
        value: 'DASH',
        label: 'DASH',
        symbol: 'DASH',
        allowNewAccounts: false,
        canDeposit: true,
        isCrypto: true,
    },
    CUD: {
        value: 'CUD',
        label: 'CUD',
        symbol: 'CUD',
        allowNewAccounts: true,
        canDeposit: true,
        isVirtualCurrency: true,
        baseCurrency: 'USD',
        baseCurrencyRate: 100,
    },
    ZAR: {
        value: 'ZAR',
        label: 'ZAR',
        symbol: 'ZAR',
        allowNewAccounts: true,
        canDeposit: true,
        allowDynamicLeverage: true,
    },
});
export const newAccountCurrencies = pickBy(currencies, (currency) => currency.allowNewAccounts);
export const newCryptoWalletCurrencies = pickBy(currencies, (currency) => currency.allowNewCryptoWallets);
export const reconciliationCurrencies = generateKeys({
    VND: {
        value: 'VND',
        label: 'Vietnamese Dong',
    },
    NGN: {
        value: 'NGN',
        label: 'Nigerian Naira',
    },
    KES: {
        value: 'KES',
        label: 'Kenyan Shilling',
    },
    GHS: {
        value: 'GHS',
        label: 'Ghanaian Cedi',
    },
    UGX: {
        value: 'UGX',
        label: 'Ugandan Shilling',
    },
    RWF: {
        value: 'RWF',
        label: 'Rwandan Franc',
    },
    ZMW: {
        value: 'ZMW',
        label: 'Zambian Kwacha',
    },
    XAF: {
        value: 'XAF',
        label: 'CFA Franc BEAC',
    },
    CLP: {
        value: 'CLP',
        label: 'Chilean Peso',
    },
    TZS: {
        value: 'TZS',
        label: 'Tanzanian Shilling',
    },
    BBD: {
        value: 'BBD',
        label: 'Barbadian Dollar',
    },
    BIF: {
        value: 'BIF',
        label: 'Burundian Franc',
    },
    BHD: {
        value: 'BHD',
        label: 'Bahraini Dinar',
    },
    MWK: {
        value: 'MWK',
        label: 'Malawian Kwacha',
    },
    OMR: {
        value: 'OMR',
        label: 'Omani Rial',
    },
    PKR: {
        value: 'PKR',
        label: 'Pakistani Rupee',
    },
    QAR: {
        value: 'QAR',
        label: 'Qatari Rial',
    },
    SAR: {
        value: 'SAR',
        label: 'Saudi Riyal',
    },
    TND: {
        value: 'TND',
        label: 'Tunisian Dinar',
    },
    TTD: {
        value: 'TTD',
        label: 'Trinidad and Tobago Dollar',
    },
    CUD: {
        value: 'CUD',
        label: 'CUD',
    },
    BTC: {
        value: 'BTC',
        label: 'Bitcoin',
        isCrypto: true,
    },
    BCH: {
        value: 'BCH',
        label: 'Bitcoin Cash / BCC',
        isCrypto: true,
    },
    ETH: {
        value: 'ETH',
        label: 'Ethereum',
        isCrypto: true,
    },
    EOS: {
        value: 'EOS',
        label: 'EOS',
        isCrypto: true,
    },
    XRP: {
        value: 'XRP',
        label: 'Ripple',
        isCrypto: true,
    },
    BSV: {
        value: 'BSV',
        label: 'Bitcoin SV',
        isCrypto: true,
    },
    USDT: {
        value: 'USDT',
        label: 'Tether',
        isCrypto: true,
    },
    USDC: {
        value: 'USDC',
        label: 'USD Coin',
        isCrypto: true,
    },
    PEN: {
        value: 'PEN',
        label: 'Peruvian Sol',
    },
    COP: {
        value: 'COP',
        label: 'Colombian Peso',
    },
    AED: {
        value: 'AED',
        label: 'United Arab Emirates Dirham',
    },
    MAD: {
        value: 'MAD',
        label: 'Moroccan Dirham',
    },
});
export const genders = generateKeys({
    male: {
        value: 'male',
        label: 'Male',
    },
    female: {
        value: 'female',
        label: 'Female',
    },
    other: {
        value: 'other',
        label: 'Other',
    },
});
export const orderDirections = generateKeys({
    ascending: {
        value: 'asc',
        label: 'Ascending',
    },
    descending: {
        value: 'desc',
        label: 'Descending',
    },
});
export const unset = generateKeys({
    unset: {
        value: 'unset',
    },
});
export const securityTokenTypes = generateKeys({
    passwordReset: {
        value: 'password_reset',
    },
    emailConfirmation: {
        value: 'email_confirmation',
    },
    loginVerification: {
        value: 'login_verification',
    },
    emailLoginVerification: {
        value: 'email_login_verification',
    },
});
export const connectionStatus = generateKeys({
    disconnected: {},
    connected: {},
    reconnecting: {},
});
export const migrationTypes = generateKeys({
    myAffiliates: { value: 'my_affiliates' },
    default: { value: 'no_migration' },
    spotOption: { value: 'spot_option' },
});
export const goldSubscriptionPlans = generateKeys({
    monthly49: {
        planCode: 'gold-m-49',
        currency: 'EUR',
        defaultAmount: 49,
        setupFee: 500,
        label: 'Monthly',
        bonus: 0,
    },
    monthly99: {
        planCode: 'gold-m-99',
        currency: 'EUR',
        defaultAmount: 99,
        setupFee: 750,
        label: 'Monthly',
        bonus: 1,
    },
    monthly149: {
        planCode: 'gold-m-149',
        currency: 'EUR',
        defaultAmount: 149,
        setupFee: 1000,
        label: 'Monthly',
        bonus: 2,
    },
    monthly199: {
        planCode: 'gold-m-199',
        currency: 'EUR',
        defaultAmount: 199,
        setupFee: 1250,
        label: 'Monthly',
        bonus: 2.5,
    },
    monthly249: {
        planCode: 'gold-m-249',
        currency: 'EUR',
        defaultAmount: 249,
        setupFee: 1500,
        label: 'Monthly',
        bonus: 3,
    },
});
export const eIdVerificationReliabilityTrulioo = generateKeys({
    Verified: {
        value: 'Verified',
        label: 'Verified',
        bsStyle: 'success',
    },
    Unverified: {
        value: 'Unverified',
        label: 'Unverified',
        bsStyle: 'danger',
    },
});
export const eIdVerificationReliability = generateKeys({
    good: {
        value: 10,
        label: 'Good',
        bsStyle: 'success',
    },
    probable: {
        value: 20,
        label: 'Probable',
        bsStyle: 'warning',
    },
    doubtful: {
        value: 30,
        label: 'Doubtful',
        bsStyle: 'danger',
    },
    verified: {
        value: 'Verified',
        label: 'Verified',
        bsStyle: 'success',
    },
    unverified: {
        value: 'Unverified',
        label: 'Unverified',
        bsStyle: 'danger',
    },
    nonResult: {
        value: 0,
        label: 'Non-Result',
        bsStyle: 'danger',
    },
});
export const eIdMatchTypes = generateKeys({
    '1MT': {
        value: '1MT',
        bsStyle: 'success',
        label: 'Full Match',
    },
    '2MT': {
        value: '2MT',
        bsStyle: 'danger',
        label: 'No Match',
    },
    '3MT': {
        value: '3MT',
        bsStyle: 'warning',
        label: 'Partial Match',
    },
    '4MT': {
        value: '4MT',
        bsStyle: 'danger',
        label: 'Not Available in Datasource',
    },
});
export const eIdDataSourceCodes = generateKeys({
    CRD: {
        value: 'CRD',
        label: 'Credit',
    },
    GVT: {
        value: 'GVT',
        label: 'Government',
    },
    PST: {
        value: 'PST',
        label: 'Postal',
    },
    CMM: {
        value: 'CMM',
        label: 'Commercial',
    },
    CNS: {
        value: 'CNS',
        label: 'Consumer',
    },
    OTH: {
        value: 'OTH',
        label: 'Other',
    },
    UTL: {
        value: 'UTL',
        label: 'Utility',
    },
    PRP: {
        value: 'PRP',
        label: 'Proprietary',
    },
    TEL: {
        value: 'TEL',
        label: 'Telco',
    },
});
export const transactionTypes = generateKeys({
    deposit: {
        value: 'deposit',
        label: 'Deposit',
    },
    withdrawal: {
        value: 'withdrawal',
        label: 'Withdrawal',
    },
    subscription: {
        value: 'subscription',
        label: 'Subscription',
    },
    transfer: {
        value: 'transfer',
        label: 'Transfer',
        isTransfer: true,
    },
    dividend: {
        value: 'dividend',
        label: 'Dividend',
    },
    ldTransfer: {
        value: 'ldTransfer',
        label: 'Payment Agent Transfer',
        isTransfer: true,
    },
});
export const telephonyProviders = generateKeys({
    impactech: {
        value: 'impactech',
        label: 'ImpacTech',
    },
    didlogic: {
        value: 'didlogic',
        label: 'DID Logic',
    },
});
export const priorities = generateKeys({
    low: {
        value: 'low',
        label: 'Low',
        color: 'rgb(76, 154, 255)',
    },
    medium: {
        value: 'medium',
        label: 'Medium',
        color: 'rgb(255, 196, 0)',
    },
    high: {
        value: 'high',
        label: 'High',
        color: 'rgb(255, 86, 48)',
    },
});
export const leverageTypes = generateLocalization('leverageTypes', generateKeys({
    defaultLeverage: {
        value: 'default_leverage',
        label: 'Default Leverage',
        localization: { id: '', defaultMessage: '' },
    },
    dynamicLeverage: {
        value: 'dynamic_leverage',
        label: 'Dynamic Leverage',
        localization: { id: '', defaultMessage: '' },
    },
}));
